import { Dimensions, MouseEventCoords } from '@mi-front/core';
import { styled } from '@mui/material/styles';
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';

const StyledWrapper = styled('div')({
  cursor: 'pointer',
  position: 'absolute',
  top: 0,
  left: 0,
});

type Props = Dimensions & {
  onHover?: (coords: MouseEventCoords) => void;
  onClick?: (coords: MouseEventCoords) => void;
  onBlur?: (coords: MouseEventCoords) => void;
  cursor?: string;
};

function convertCoords([x, y]: [number, number]): MouseEventCoords {
  return { x, y };
}

export function ClickableArea(p: Props) {
  const areaRef = useRef(null);

  useEffect(() => {
    const { onClick, onHover, onBlur } = p;
    const el = areaRef.current!;

    const onMouseDown = () => {
      onClick && onClick(convertCoords(d3.mouse(el)));
    };

    const onMouseMove = () => {
      onHover && onHover(convertCoords(d3.mouse(el)));
    };

    const onMouseOut = () => {
      onBlur && onBlur(convertCoords(d3.mouse(el)));
    };

    // the new handlers will replace any existing one
    // according to the d3 documentation https://d3js.org/d3-selection/events
    d3.select(el)
      .on('mousedown', onMouseDown)
      .on('mousemove', onMouseMove)
      .on('mouseout', onMouseOut);
  }, [p.onClick, p.onHover, p.onBlur]);

  return (
    <StyledWrapper
      data-testid="clickable-area"
      style={{
        height: p.height,
        width: p.width,
        cursor: p.cursor || 'pointer',
      }}
      ref={areaRef}
    />
  );
}
